import { _ } from "../helpers/dom-selectors.js";
function makeEntityData({ scriptTag }) {
    let initialized = false;
    let ENTITIES = [];
    return Object.freeze({
        init,
        getAll,
        add,
        removeById
    });
    function init() {
        if (initialized)
            return;
        const serverData = JSON.parse(scriptTag.textContent);
        if (!Array.isArray(serverData))
            return;
        serverData.forEach(entity => {
            ENTITIES.push({
                id: entity.id,
                title: entity.title
            });
        });
        initialized = true;
    }
    function getAll() {
        return ENTITIES;
    }
    function add(entity) {
        ENTITIES.push(entity);
    }
    function removeById(id) {
        const index = ENTITIES.findIndex(e => e.id === id);
        if (index === -1)
            return;
        ENTITIES.splice(index, 1);
    }
}
const ENTITY_DATA = makeEntityData({ scriptTag: _('SERVER_DATA') });
export default ENTITY_DATA;
